import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { PetPurchase } from 'shared/@types';

const useInboxStore = create(
  combine(
    {
      unreadCount: null as number | null,
      petPurchases: [] as PetPurchase[],
    },
    (set) => ({
      setPetPurchases: (petPurchases: PetPurchase[]) => {
        set({ petPurchases });
      },
      setUnreadCount: (unreadCount: number) => {
        set({ unreadCount });
      },
      reset: () => {
        set({ unreadCount: null, petPurchases: [] });
      },
    }),
  ),
);

export default useInboxStore;
